<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='作者列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-button type="primary" @click="showAddDialog">添加作者</el-button>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.source_id" placeholder="请选择来源" @change="getAuthorList" filterable>
            <el-option label="请选择来源" :value="0"></el-option>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="authorList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="title" label="名称" align="center"></el-table-column>
      <el-table-column prop="source_title" label="来源" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <handpick-author-add
      :visible="addDialogAvaible"
      :id="currentId"
      :sourceList="sourceList"
      @add="addGroup"
      @update="updateGroup"
      @closeDialog="closeAddDialog">
    </handpick-author-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import handpickAuthorAddVue from './handpickAuthorAdd.vue'
export default {
  name: 'handpick_author_list',
  components: {
    'bread-crumb': BreadCrumb,
    'handpick-author-add': handpickAuthorAddVue
  },
  data () {
    return {
      sourceList: [],
      authorList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        source_id: 0,
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getAuthorList()
    this.getSourceList()
  },
  methods: {
    async getAuthorList () {
      const res = await this.$http.get('/admin/handpick_author/list', this.param)
      if (res.code === 0) {
        this.authorList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSourceList () {
      const res = await this.$http.get('/admin/handpick_source/select_list')
      if (res.code === 0) {
        this.sourceList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getAuthorList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getAuthorList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/handpick_author/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getAuthorList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addGroup (data) {
      const res = await this.$http.post('/admin/handpick_author/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getAuthorList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateGroup (id, data) {
      const res = await this.$http.post('/admin/handpick_author/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getAuthorList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
